import { getApi } from './index';
import { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import { hasAuthCookies } from 'util/auth-cookie-util';

const authStrategy = hasAuthCookies() ? AuthStrategy.AUTH_TOKEN : AuthStrategy.HTTP_AUTHENTICATION;

const createLog = async (type: string, data: any) => {
  getApi(authStrategy)
    .onError(() => null)
    .createTelemetryEvent({
      url: '/logs',
      payload: { type, data },
    });
};

export { createLog };
